import { Calculation } from "../models/Calculation";
import { CalculationField } from "../models/CalculationField";
import { CalculationSchema } from "../models/CalculationSchema";

export class CalculationsTypeGuardService {

    private static readonly CALCULATION_TYPES_THAT_SUPPORT_CHILD_CALCULATIONS = [];

    public static isCalculation(obj: unknown): obj is Calculation {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            '_type' in obj &&
            typeof (obj as any)._type === 'string'
        );
    }

    public static isCalculationField(obj: unknown): obj is CalculationField {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'name' in obj &&
            'field_type' in obj &&
            typeof (obj as any).name === 'string' &&
            typeof (obj as any).field_type === 'string'
        );
    }

    public static isCalculationSchema(obj: unknown): obj is CalculationSchema {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'type' in obj &&
            'display_name' in obj &&
            'fields' in obj &&
            typeof (obj as any).type === 'string' &&
            typeof (obj as any).display_name === 'string' &&
            Array.isArray((obj as any).fields)
        );
    }

    public static hasDefinedCalculationSchemaUi(calculationSchema: CalculationSchema): boolean {
        return this.isCalculationSchema(calculationSchema)
            && calculationSchema.ui != null
            && typeof calculationSchema.ui === 'object'
            && Array.isArray(calculationSchema.ui.field_groups)
            && calculationSchema.ui.field_groups.length > 0
            && calculationSchema.ui.field_groups.every(group =>
                group != null
                && typeof group === 'object'
                && Array.isArray(group.fields)
                && group.fields.length > 0
            );
    }

    public static supportsChildCalculations(obj: unknown): boolean {
        // any CalculationField with item_schema or payload_template
        // Note that we currently do not support payload_templates for calculations
        return (this.isCalculation(obj) && this.calculationTypeSupportsChildCalculations((obj as Calculation)._type))
            || (this.isPayloadTemplateCalculationSchema(obj)
                && this.calculationTypeSupportsChildCalculations((obj as CalculationSchema).payload_template?.type));
    }

    public static isPayloadTemplateCalculationSchema(obj: unknown): boolean {
        return this.isCalculationSchema(obj) && (obj as CalculationSchema).payload_template != null;
    }

    public static calculationTypeSupportsChildCalculations(calculationType?: string): boolean {
        return this.CALCULATION_TYPES_THAT_SUPPORT_CHILD_CALCULATIONS.find(x => calculationType === x) != null;
    }

    public static isNonEmptyCalculationObject(value: unknown): value is Record<string, unknown> {
        return (
            typeof value === 'object' &&
            value !== null &&
            !Array.isArray(value) &&
            Object.keys(value).length > 0
        )
    }
}
